import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useSnackbar } from 'notistack';
import {
  Box, Button, Menu, MenuItem
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { logout } from 'src/actions/accountActions';
import { clearSelectedDocument } from 'src/actions/documentActions';

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1)
  },
  popover: {
    width: 200
  },
  buttonRoot: {
    fontWeight: 'normal',
    textTransform: 'none',
    color: '#546E7A',

  }
}));

function Account({ username }) {
  const classes = useStyles();
  const history = useHistory();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      dispatch(logout());
      dispatch(clearSelectedDocument());
      history.push('/login');
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" ref={ref} color="#546E7A">
        <Button
          className={classes.buttonRoot}
          onClick={handleOpen}
          endIcon={<ArrowDropDownIcon />}
        >
          {username || ''}
        </Button>
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        anchorEl={ref.current}
        open={isOpen}
      >
        <MenuItem onClick={() => history.push('/change-password')}>
          Change Password
        </MenuItem>
        <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
      </Menu>
    </>
  );
}

Account.propTypes = {
  username: PropTypes.any,
};

export default Account;
